import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import dynamic from 'next/dynamic'

const AudioIcon = dynamic(
  () => import('@public/static/icons/advantageous/chooseEdugram/AudioIcon')
)
const BoostSalesIcon = dynamic(
  () => import('@public/static/icons/advantageous/chooseEdugram/BoostSalesIcon')
)
const LongTermIcon = dynamic(
  () => import('@public/static/icons/advantageous/chooseEdugram/LongTermIcon')
)
const MarketingAiIcon = dynamic(
  () =>
    import('@public/static/icons/advantageous/chooseEdugram/MarketingAIIcon')
)
const NewStudents = dynamic(
  () => import('@public/static/icons/advantageous/chooseEdugram/NewStudents')
)

import { useTranslation } from 'react-i18next'

type Props = {}

const ChooseEdugram = ({}: Props) => {
  const { t } = useTranslation('advantageous')

  const list = [
    {
      icon: BoostSalesIcon,
      title: t('boostYourSalesTitle'),
      description: t('boostYourSalesDescription'),
    },
    {
      icon: NewStudents,
      title: t('reachNewStudentsTitle'),
      description: t('reachNewStudentsDescription'),
    },
    {
      icon: MarketingAiIcon,
      title: t('marketingAiTitle'),
      description: t('marketingAiDescription'),
    },
    {
      icon: AudioIcon,
      title: t('audioTranslationTitle'),
      description: t('audioTranslationDescription'),
    },
    {
      icon: LongTermIcon,
      title: t('longTermEngagementTitle'),
      description: t('longTermEngagementDescription'),
    },
    {
      icon: LongTermIcon,
      title: t('inclusiveForAllAgesTitle'),
      description: t('inclusiveForAllAgesDescription'),
    },
  ]
  return (
    <Container>
      <ContainerWrapper>
        <Header>{t('whyChooseEdugram')}</Header>
        <ContentWrapper>
          {list.map((item) => (
            <ContentItem key={item.description}>
              <ContentItemTop>
                <ContentIcon className="bg-opacity-[0.25] rounded-full bg-uguBrightPurple">
                  <item.icon />
                </ContentIcon>
                <ContentTitle>{item.title}</ContentTitle>
              </ContentItemTop>
              <ContentDescription>{item.description}</ContentDescription>
            </ContentItem>
          ))}
        </ContentWrapper>
      </ContainerWrapper>
    </Container>
  )
}

export default ChooseEdugram

const Container = styled.div`
  min-height: 776px;
  max-width: 1600px;
  margin: 8rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem 2rem;
  @media screen and (max-width: 596px) {
    align-items: flex-start;
    padding: 0px 1rem;
  }
`
const Header = styled.div`
  font-family: Sofia Pro;
  font-weight: 600;
  text-align: center;
  margin: 4.5rem 0rem;
  color: ${colors.uguPurple};
  line-height: 5rem;
  font-size: 5rem;
  @media screen and (max-width: 1024px) {
    line-height: 4rem;
    font-size: 4rem;
  }
  @media screen and (max-width: 596px) {
    font-size: 36px;
    line-height: 36px;
    text-align: left;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 5rem;
  justify-content: center;
  max-width: 1440px;
  @media screen and (max-width: 1024px) {
    justify-content: space-around;
  }
  @media screen and (max-width: 596px) {
    justify-content: flex-start;
  }
`
const ContentItem = styled.div`
  width: 366px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (max-width: 1024px) {
    width: 360px;
  }
  @media screen and (max-width: 386px) {
    width: 100%;
  }
`
const ContentItemTop = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
const ContentIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ContentTitle = styled.div`
  font-family: Sofia Pro;
  font-weight: 600;
  text-align: left;
  color: ${colors.uguPurple};
  font-size: 24px;
  line-height: 24px;
  /* @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 24px;
  } */
  @media screen and (max-width: 596px) {
    font-size: 24px;
    line-height: 24px;
  }
`
const ContentDescription = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-weight: 500;
  text-align: left;
  color: ${colors.uguPurple};
  font-size: 18px;
  line-height: 24px;
  /* @media screen and (max-width: 1024px) {
    font-size: 18px;
    line-height: 18px;
  } */
  @media screen and (max-width: 596px) {
    font-size: 16px;
    line-height: 20px;
  }
`
